import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_ONE_QUESTION_CATEGORY } from 'queries/questionCategory'
import { findOneQuestionCategory, findOneQuestionCategoryVariables } from '__generatedTypes__/findOneQuestionCategory'
import { searchQuestionCategory_searchQuestionCategory_items as QuestionCategory } from '__generatedTypes__/searchQuestionCategory'
import { QUESTION_CATEGORY_PARAM } from './List/consts'

export function useInitialCategoryFromUrl() {
  const [searchParams] = useSearchParams()
  const [initialCategoryId] = useState(() => searchParams.get(QUESTION_CATEGORY_PARAM))

  const [categoryDisplayValue, setCategoryDisplayValue] = useState<QuestionCategory | null>(() =>
    initialCategoryId ? ({ id: initialCategoryId } as QuestionCategory) : null
  )

  const { data, loading, error } = useQuery<findOneQuestionCategory, findOneQuestionCategoryVariables>(
    GET_ONE_QUESTION_CATEGORY,
    { variables: { params: initialCategoryId as string }, skip: !initialCategoryId }
  )

  useEffect(() => {
    const category = data?.findOneQuestionCategory
    if (category) {
      setCategoryDisplayValue(category as unknown as QuestionCategory)
    }
  }, [data?.findOneQuestionCategory])

  return {
    categoryDisplayValue,
    setCategoryDisplayValue,
    loadingInitialCategory: !!initialCategoryId && loading,
    errorInitialCategory: !!initialCategoryId && error,
    initialCategoryFilter: initialCategoryId
      ? { questionCategory: { id: initialCategoryId } as QuestionCategory }
      : undefined,
  }
}
